import webBiLogger from '@wix/web-bi-logger';
import * as eventBuilderFunc from '@wix/bi-logger-logo-builder/v2';
import { ClientPersistanceService } from './ClientPersistanceService';
import shortId from 'shortid';
const logger = webBiLogger.factory().logger();
export const BIZ_MGR_BI_CONTAINER = 'biz-mgr';
export const LOGO_BI_CONTAINER = 'logo-standalone';
export const PRINT_STANDALONE_BI_CONTAINER = 'prints-standalone';
export const BRAND_STANDALONE = 'brand_standalone';
export const BRAND_BIZ_MGR_BI_CONTAINER = 'brand-biz-mgr';
export const LOGO_EDITOR_COMPONENT = 'logo-editor-component';
export const SOCIAL_MARKETING_BM = 'social_marketing_bm';
let container = '';
let userEntry = '';
let sessionId = '';
let packageType;
let brandId;
let msid = '';
let isActiveBrandKit = false;
const clientPersistanceService = new ClientPersistanceService('logo-universal');
export function setBiContainerName(containerName) {
    container = containerName;
    setUserEntry();
}
export function setBiMSID(inputMSID) {
    msid = inputMSID;
}
export function initSessionId(options = {}) {
    sessionId = shortId();
    const oneDayInSeconds = 60 * 60 * 24;
    clientPersistanceService.set('biSessionId', sessionId, { expiration: oneDayInSeconds });
    const { screenName } = options;
    biLog('logoBuilderSessionCreated', { logoSessionId: sessionId, screenName });
}
async function getSessionId() {
    if (!sessionId) {
        sessionId = await clientPersistanceService.get('biSessionId');
    }
    return sessionId;
}
function setUserEntry() {
    if (container === LOGO_BI_CONTAINER) {
        userEntry = 'standalone';
    }
    else if (container === BIZ_MGR_BI_CONTAINER) {
        userEntry = BIZ_MGR_BI_CONTAINER;
    }
    else if (container === PRINT_STANDALONE_BI_CONTAINER) {
        userEntry = PRINT_STANDALONE_BI_CONTAINER;
    }
    else if (container === BRAND_STANDALONE) {
        userEntry = BRAND_STANDALONE;
    }
    else if (container === BRAND_BIZ_MGR_BI_CONTAINER) {
        userEntry = BRAND_BIZ_MGR_BI_CONTAINER;
    }
    else if (container === LOGO_EDITOR_COMPONENT) {
        userEntry = LOGO_EDITOR_COMPONENT;
    }
    else if (container === SOCIAL_MARKETING_BM) {
        userEntry = SOCIAL_MARKETING_BM;
    }
}
export function setBrandId(id) {
    brandId = id;
}
export function setPackageType(type) {
    packageType = type;
}
export function setIsActiveBrandKit(isActive) {
    isActiveBrandKit = isActive;
}
export const biLog = async (funcName, params) => {
    var _a, _b;
    const logoSessionId = await getSessionId();
    if (eventBuilderFunc[funcName] && typeof eventBuilderFunc[funcName] === 'function') {
        const brandGuid = (_a = params === null || params === void 0 ? void 0 : params.brandGuid) !== null && _a !== void 0 ? _a : brandId;
        const _msid = (_b = params === null || params === void 0 ? void 0 : params.msid) !== null && _b !== void 0 ? _b : msid;
        logger.report(eventBuilderFunc[funcName](Object.assign(Object.assign({}, params), { container, userEntry, logoSessionId, brandGuid, packageType, msid: _msid, isActiveBrandKit })));
    }
    else {
        console.error(`[biService.js:biLog] ${funcName} does not exists`);
    }
};
export const biLogSafe = callback => {
    if (callback && typeof callback === 'function') {
        try {
            callback(biLog, logger);
        }
        catch (error) {
            console.error(`[biService.js:biLogSafe] error`, error.message);
        }
    }
    else {
        console.error(`[biService.js:biLogSafe] callback is not a function`);
    }
};
//# sourceMappingURL=biService.js.map